export const optimizedAppearDataId = "framerAppearId"

export const optimizedAppearDataAttribute = "data-framer-appear-id"
